export default "__VITE_IMAGE_ASSET__8bbaedf5__";